import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const setUser = createAction(ACTION.SET_USER, (user) => ({user}));
export const authSuccess = createAction(ACTION.AUTH_SUCCESS, (token, callbackUrl = '') => ({token, callbackUrl}));
export const logout = createAction(ACTION.LOGOUT);
